import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDataFusionCustomerLookup extends Layout {
    sourceEdiCustomer: DataSource;
    tableCustomerLookup: Table;
}
